module.exports = __webpack_public_path__ + "img/js@2x.b2045c67.png";